import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
    createPrivacySetting,
    deletePrivacySetting,
    listPrivacySetting,
    editPrivacySetting,
    viewPrivacySetting
} from "@/services/privacySetting";
@Module({
    namespaced: true,
})
export default class privacySetting extends VuexModule {
    // state
    editPrivacySettingData = null;


    // actions
    @Action
    public async createPrivacySettingAction(payload) {
        try {
            return await createPrivacySetting(payload);
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async deletePrivacySettingAction(payload) {
        try {
            return await deletePrivacySetting(payload);
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async listPrivacySettingAction(id) {
        try {
            return await listPrivacySetting(id);
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async editPrivacySettingAction(payload) {
        try {
            const result = await editPrivacySetting(payload);
            return result;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async viewPrivacySettingAction(payload) {
        try {
            const result = await viewPrivacySetting(payload.tenant, payload.content, payload.slug);
            this.context.commit("setViewPrivacySettingData", result.data);
            return result;
        } catch (error) {
            throw error;
        }
    }
    // mutations
    @Mutation
    public setViewPrivacySettingData(data: any) {
        this.editPrivacySettingData = data;
    }
    // getters
    get GetEditPrivacySettingData() {
        return this.editPrivacySettingData;
    }
}
